import React from 'react';
import { useContent } from '../../context/ContentContext';
import ContactEmail from './contactEamil';
import './contact.css';
const Contact = () => {
  const { content } = useContent();
  const contactInfo = content.contact;


  const openGoogleMaps = () => {
    const address = encodeURIComponent(contactInfo.address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="contact__header">
          <span className="section__subtitle" style={{color: 'black', fontSize: '1.25rem'}}>CONTACT US or VISIT OUR OFFICE</span>
    
        </div>

        <div className="contact__container grid">
 
        <div>
           <ContactEmail/>
        </div>
          <div className="contact__info">
    
            <div className="contact__map">
              <div className="map-container">
                <div className="map-placeholder">
                  <div className="location-marker">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div className="location-info">
                    <h3>Our Location</h3>
                    <p>{contactInfo.address}</p>
                    <button onClick={openGoogleMaps} className="button button--small">
                      Open in Google Maps
                    </button>
                  </div>
                </div>
              </div>
            </div>

  
            <div className="contact-cards grid">
              <div className="contact-card">
                <div className="contact-card__icon">
                  <i className="ri-map-pin-2-line"></i>
                </div>
                <div className="contact-card__content">
                  <h4>Address</h4>
                  <p>{contactInfo.address}</p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <i className="ri-phone-line"></i>
                </div>
                <div className="contact-card__content">
                  <h4>Phone</h4>
                  <p>{contactInfo.phone}</p>
                  {contactInfo.phone2 && <p>{contactInfo.phone2}</p>}
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <i className="ri-mail-line"></i>
                </div>
                <div className="contact-card__content">
                  <h4>Email</h4>
                  <p>{contactInfo.email}</p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <i className="ri-time-line"></i>
                </div>
                <div className="contact-card__content">
                  <h4>Working Hours</h4>
                  <p>Mon-Fri: {contactInfo.hours.weekday}</p>
                  <p>Sat: {contactInfo.hours.saturday}</p>
                  <p>Sun: {contactInfo.hours.sunday}</p>
                </div>
              </div>
            </div>

            <div className="contact__social">
              <h4>Connect With Us</h4>
              <div className="social-links">
                <a 
                  href="https://api.whatsapp.com/send?phone=+211918882661&text=Hello, more information!" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link whatsapp"
                >
                  <i className="ri-whatsapp-line"></i>
                </a>
                <a 
                  href="https://m.me/farmosouthsudan.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link messenger"
                >
                  <i className="ri-messenger-line"></i>
                </a>
                <a 
                  href="https://t.me/farmosouthsudan.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link telegram"
                >
                  <i className="ri-telegram-line"></i>
                </a>
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="social-link email"
                >
                  <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>
          </div>
           
        </div>

  
      </div>
    </section>
  );
};

export default Contact;